import { render, staticRenderFns } from "./universal_header.vue?vue&type=template&id=b2f24fb2"
import script from "./universal_header.vue?vue&type=script&lang=js"
export * from "./universal_header.vue?vue&type=script&lang=js"
import style0 from "./universal_header.vue?vue&type=style&index=0&id=b2f24fb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports